import { ModuleWithProviders, NgModule } from '@angular/core';
import { GenSubscriptionsComponent } from './subscriptions.component';
import { CommonModule } from '@angular/common';
import { SpinnerModule } from "@spartacus/storefront";
import { GenProductGridItemComponent } from '../product/product-list/product-grid-item/product-grid-item.component';

@NgModule({
  declarations: [GenSubscriptionsComponent],
  imports: [
    CommonModule,
    GenProductGridItemComponent,
    SpinnerModule,
  ],
})
export class GenSubscriptionsModule {
  static forRoot(): ModuleWithProviders<GenSubscriptionsModule> {
    return {
      ngModule: GenSubscriptionsModule,
    };
  }
}
